import { InjectionToken } from '@angular/core';

export const UI_SWITCH_OPTIONS = new InjectionToken('UI_SWITCH_OPTIONS');
